import React from 'react'

const H1 = (props) => <h1 {...props} />

export default H1
